import { Link } from "react-router-dom";
import Slider from "react-slick";
import { useEffect, useState } from "react";
import axios from "axios";

import API_ROUTES from "../constants/apis";

import students from "../assets/students.jpg";
import market from "../assets/market.jpg";
import student from "../assets/student.svg";
import student2 from "../assets/student2.svg";
import student3 from "../assets/kwasu.jpg";

import { GiCctvCamera } from "react-icons/gi";
import { GiTap } from "react-icons/gi";
import { GiBed } from "react-icons/gi";
import { AiFillCar } from "react-icons/ai";
import { BsShop } from "react-icons/bs";
import { GiTabletopPlayers } from "react-icons/gi";

import Navbar from "./Navbar";
import Footer from "./Footer";

const Home = (user) => {
  const [residencies, setResidencies] = useState([]);

  useEffect(() => {
    axios
      .get(`${API_ROUTES.HOSTEL}`)
      .then((response) => {
        setResidencies(response.data);
      })
      .catch((error) => {
        console.error("Error fetching residence details:", error);
      });
  }, []);

  const latestResidence =
    residencies.length > 0 ? residencies[residencies.length - 1] : null;

  const imageUrl = "https://res.cloudinary.com/ddtmsdlip/";

  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const feature = {
    autoplay: true,
    autoplaySpeed: 2000,
    speed: 700,
    infinite: true,
    pauseOnHover: true,
    arrows: true,
    dots: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <>
      <Navbar />

      <main className="mx-auto text-white bg-slate-300">
        <section className="h-screen overflow-hidden">
          <Slider {...settings} className="max-w-full">
            <div className="h-90vh bg-blue-950 relative">
              <div className="text-blue-950 font-bold p-4 absolute left-0 bottom-0 transform -translate-y-1/2 md:translate-x-1/2">
                <div className="bg-pink-600 text-xl px-3 py-1">Looking for</div>{" "}
                <div className="bg-sky-500 text-2xl my-2 px-3 py-1 font-extrabold">
                  Accommodation
                </div>{" "}
                <div className="bg-pink-600 text-xl px-3 py-1">
                  around your Campus?
                </div>{" "}
                <button
                  type="submit"
                  className="bg-red-600 hover:bg-red-700 p-2 rounded-md mt-1"
                >
                  Book Now
                </button>
              </div>
              <img src={student} alt="" className="h-full w-full" />
            </div>
            <div className="h-90vh bg-blue-950 relative">
              <div className="text-blue-950 font-bold p-4 absolute left-0 bottom-0 transform -translate-y-1/2 md:translate-x-1/2">
                <div className="bg-pink-600 text-xl px-3 py-1">
                  Your Favorite
                </div>{" "}
                <div className="bg-sky-500 text-2xl my-2 px-3 py-1 font-extrabold">
                  Comrade Hostels
                </div>{" "}
                <div className="bg-pink-600 text-xl px-3 py-1">
                  around your Campus?
                </div>{" "}
                <button
                  type="submit"
                  className="bg-red-600 hover:bg-red-700 p-2 rounded-md mt-1"
                >
                  Book Now
                </button>
              </div>
              <img src={student2} alt="" className="h-full w-full" />
            </div>
            <div className="h-90vh bg-blue-950 relative">
              <div className="text-4xl md:text-5xl lg:text-6xl text-blue-950 font-bold p-4 absolute left-0 bottom-0 transform -translate-y-1/2 md:translate-x-1/2">
                {latestResidence && (
                  <div className="bg-sky-500 my-2 px-3 py-1 font-extrabold">
                    {latestResidence.name}
                  </div>
                )}{" "}
                <div className="bg-pink-600 px-3 py-1">
                  Ready for May Intake.
                </div>{" "}
                <button
                  type="submit"
                  className="bg-red-600 hover:bg-red-700 p-2 rounded-md mt-1 text-2xl"
                >
                  Book Now
                </button>
              </div>
              <img src={student3} alt="" className="h-full w-full" />
            </div>
          </Slider>
        </section>
        <section className="about flex flex-col pb-16 px-5 md:px-36 lg:px-60 xl:px-96 text-blue-950">
          <h2 className="text-center text-4xl font-extrabold">About</h2>

          <div className="about-details grid gap-8 grid-cols-1 md:grid-cols-2">
            <div className="about-image border-4 border-red-600 rounded-full">
              <img src={market} alt="" className="h-full w-full rounded-full" />
            </div>
            <div className="about-desc flex justify-center items-center">
              Duis a lorem tristique, faucibus erat non, rhoncus leo.
              Pellentesque habitant morbi tristique senectus et netus et
              malesuada fames ac turpis egestas.uere, felis non porta tincidunt,
              libero ipsum tempus diam, eget molestie risus augue eu nunc.
              Aenean tincidunt velit sit amet ipsum gravida maximus.
            </div>
          </div>
        </section>

        <section className="hostels bg-sky-500  py-16 px-5 md:px-36 lg:px-60 xl:px-96 text-blue-950">
          <p className="text-center text-2xl text-blue-950 font-bold">
            Find a <span className="text-white">StudentKeja</span> student
            residence near you
          </p>

          <div className="flex justify-center">
            <div className="flex p-4">
              <Link
                to="/search"
                className="bg-pink-500 hover:bg-red-700 text-white p-2 rounded-lg"
              >
                Click to Search Residencies
              </Link>
            </div>
          </div>

          {latestResidence && (
            <div className="latestkeja md:flex mt-5 bg-pink-500">
              <div className="image hidden md:block w-1/2">
                <img
                  src={imageUrl + latestResidence.picture}
                  alt="keja"
                  className="w-full h-full"
                />
              </div>
              <div className="desc flex flex-col lg:flex-row">
                <div className="p-4 lg:w-1/2">
                  <h1 className="name font-bold text-xl text-center">
                    {latestResidence.name}
                  </h1>
                  <p className="desc">{latestResidence.description}</p>
                </div>
                <div className="right flex flex-col justify-center items-center p-4 lg:w-1/2">
                  <div>
                    <span className="font-bold text-4xl text-sky-500">500</span>{" "}
                    <br /> Students Living
                  </div>
                  <div className="book mt-5">
                    <Link
                      to="/residencies"
                      className="bg-blue-950 hover:bg-red-700 text-white p-2 rounded-lg"
                    >
                      View All Residencies
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          )}
        </section>

        <section className="features  py-16 px-5 md:px-36 lg:px-60 xl:px-96 text-blue-950">
          <h2 className="text-center text-4xl font-extrabold">Key Features</h2>
          <div className="">
            <Slider {...feature} className="max-w-full py-10">
              <div className="flex p-4 ">
                <div className="flex justify-center">
                  <GiCctvCamera className="text-6xl text-red-600 border-2 border-sky-500 border-dotted rounded-full w-1/2 " />
                </div>
                <p className="text-center">
                  CCtv and 24/7 safety and security team ready to respond
                </p>
              </div>
              <div className="flex p-4 ">
                <div className="flex justify-center">
                  <GiTap className="text-6xl text-red-600 border-2 border-sky-500 border-dotted rounded-full w-1/2 " />
                </div>
                <p className="text-center">
                  Plenty of Water Supply in Laundry, Kitchen, Other hostels
                  usage and even safe for drinking.
                </p>
              </div>
              <div className="flex p-4 ">
                <div className="flex justify-center">
                  <AiFillCar className="text-6xl text-red-600 border-2 border-sky-500 border-dotted rounded-full w-1/2 " />
                </div>
                <p className="text-center">
                  Ample Parking space for students with cars.
                </p>
              </div>
              <div className="flex p-4 ">
                <div className="flex justify-center">
                  <BsShop className="text-6xl text-red-600 border-2 border-sky-500 border-dotted rounded-full w-1/2 " />
                </div>
                <p className="text-center">Front Shops</p>
              </div>
              <div className="flex p-4 ">
                <div className="flex justify-center">
                  <GiBed className="text-6xl text-red-600 border-2 border-sky-500 border-dotted rounded-full w-1/2 " />
                </div>
                <p className="text-center">Availability of beds </p>
              </div>
              <div className="flex p-4 ">
                <div className="flex justify-center">
                  <GiTabletopPlayers className="text-6xl text-red-600 border-2 border-sky-500 border-dotted rounded-full w-1/2 " />
                </div>
                <p className="text-center">Provision of study tables</p>
              </div>
            </Slider>
          </div>
        </section>
        <section
          className="join bg-blue-950 py-16 px-5 md:px-36 lg:px-60 xl:px-96"
          style={{
            backgroundImage: `linear-gradient(to left, rgba(255,255,255,0), rgba(255,255,255,1)), url(${students})`,
            backgroundSize: "cover",
            backgroundPosition: "right",
            backgroundBlendMode: "multiply",
          }}
        >
          <h2 className="text-4xl font-extrabold text-red-600">Join Us Now.</h2>
          <p className="text-3xl leading-loose text-sky-500">
            Make <span className="font-extrabold">Marisu</span> Your new
            Community
          </p>
          <p className="leading-loose">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur
            diam quam, tincidunt euismod quam at, eleifend sodales leo. Aenean
            sit amet tristique erat. Nunc consequat lectus nulla, sit amet
            elementum erat faucibus non.
          </p>
          <button
            type="submit"
            className="bg-red-600 hover:bg-red-700 p-2 rounded-md mt-5"
          >
            Book Now
          </button>
        </section>

        <section className="contact py-10 px-5 md:px-36 lg:px-60 xl:px-96 text-blue-950">
          <h3 className="text-center text-3xl font-bold ">Contact Us</h3>
          <div className="form">
            <form action="" className="flex flex-col">
              <label className="block py-2">
                <span className="after:content-['*'] after:ml-0.5 after:text-red-600 block text-sm font-medium">
                  Full Name
                </span>
                <input
                  type="text"
                  name="title"
                  className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                  placeholder="Enter Your Full Name"
                />
              </label>
              <label className="block py-2">
                <span className="after:content-['*'] after:ml-0.5 after:text-red-600 block text-sm font-medium">
                  Email
                </span>
                <input
                  type="email"
                  name="email"
                  className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                  placeholder="you@example.com"
                />
              </label>
              <label className="block py-2">
                <span className="after:content-['*'] after:ml-0.5 after:text-red-600 block text-sm font-medium">
                  Title
                </span>
                <input
                  type="text"
                  name="title"
                  className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                  placeholder="Title"
                />
              </label>
              <label className="block py-2">
                <span className="after:content-['*'] after:ml-0.5 after:text-red-600 block text-sm font-medium">
                  Message
                </span>
                <textarea
                  name=""
                  id=""
                  cols="20"
                  rows="5"
                  defaultValue="Type Your Message Here!"
                  className="mt-1 px-3 py-2 bg-white border shadow-sm border-slate-300 placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-sky-500 block w-full rounded-md sm:text-sm focus:ring-1"
                />
              </label>

              <button
                type="submit"
                className="block rounded-md py-2 mt-2 text-white text-xl bg-sky-500 hover:bg-sky-600"
              >
                Submit
              </button>
            </form>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

export default Home;
